<template>
    <v-dialog
        v-model="searchForm"
        :content-class="`search-form-dialog` + ($conf.public.layout.searchForm.light ? ' sf-wrapper--light' : '')"
        :fullscreen="$breakpoint.smAndDown"
    >
        <template v-slot:activator="{props}">
            <v-card class="search-summary__card mb-5" variant="outlined" v-bind="checkDisabled(props)">
                <v-card-title class="text-h6 font-weight-light white-space-normal">
                    <slot name="title" />
                </v-card-title>
                <v-card-text>
                    <slot name="content">
                        <search-summary-content
                            :search-request="searchRequest"
                            :show-date="showDate"
                            :show-dates="showDates"
                            :show-days-count="showDaysCount"
                            :show-nights="showNights"
                            :show-duration="showDuration"
                            :show-tourists="showTourists"
                            :pick-up-location="pickUpLocation"
                            :drop-off-location="dropOffLocation"
                            :show-passengers="showPassengers"
                            :date-prop="dateProp"
                            :tourists-label="touristsLabel"
                        />
                    </slot>
                </v-card-text>
                <v-card-actions v-if="!searchDisabled">
                    <strong class="text-primary float-right ml-auto">{{ $t('change') }}</strong>
                </v-card-actions>
            </v-card>
        </template>
        <v-theme-provider :theme="theme" with-background style="background: transparent !important">
            <component
                :is="formComponent"
                style="width: 100%"
                :popup="true"
                :variant="searchRequest.type || searchRequest.productVariantId"
                :product-area="productArea"
                @close-popup="searchForm = false"
            />
        </v-theme-provider>
    </v-dialog>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import SearchSummaryContent from '@/components/parts/SearchSummaryContent.vue'

    @Component({
        components: {
            SearchSummaryContent,
        },
    })
    export class SearchSummaryLayout extends Vue {
        @Prop({default: false, type: Boolean}) searchDisabled
        @Prop() formComponent
        @Prop({default: () => ({})}) searchRequest
        @Prop() searchRequestReturnTransfer
        @Prop() isReturnTransfer
        @Prop({default: false, type: Boolean}) showDate
        @Prop({default: false, type: Boolean}) showDates
        @Prop({default: false, type: Boolean}) showDaysCount
        @Prop({default: false, type: Boolean}) showNights
        @Prop({default: false, type: Boolean}) showDuration
        @Prop({default: false, type: Boolean}) showTourists
        @Prop() touristsLabel
        @Prop() pickUpLocation
        @Prop() dropOffLocation
        @Prop({default: false, type: Boolean}) showPassengers
        @Prop() dateProp

        searchForm = false

        checkDisabled(on) {
            if (this.searchDisabled) return
            return on
        }

        get productArea() {
            return undefined
        }

        get theme() {
            return this.$conf.public.layout.searchForm.light ? 'light' : 'dark'
        }
    }

    export default SearchSummaryLayout
</script>

<style scoped lang="scss">
    :deep(.search-form-dialog) {
        overflow: visible;

        > .v-theme-provider > .v-card > .v-card-text {
            padding-top: 24px;
        }
    }

    @media (max-width: 960px) {
        :deep(.search-form-dialog) {
            overflow-y: scroll;
        }
    }

    .white-space-normal {
        white-space: normal;
    }
</style>
